'use strict';
import template from './informacionPCD.html';
import controller from './informacionPCD.controller';

const InformacionPCDComponent = {
  controller,
  template
};

export default InformacionPCDComponent;


// WEBPACK FOOTER //
// ./src/app/components/listados/informacionPCD/informacionPCD.component.js